import { AxiosError, AxiosResponse } from "axios";

// The API can answer 200 with a failing Status in the body. Reject those like
// a failed HTTP status, keeping the response so callers read its Message the
// same way.
export const rejectFailedStatus = <T>(response: AxiosResponse<T>) => {
  const body = response.data as { Status?: number | string; Message?: string };
  if (body?.Status !== undefined && `${body.Status}` !== "200") {
    throw new AxiosError(
      body.Message || "Something went wrong",
      AxiosError.ERR_BAD_RESPONSE,
      response.config,
      response.request,
      response
    );
  }
  return response;
};
